function getQrBase(linkMelhous) {
  return linkMelhous.replace(/\/+$/, "");
}

function saveQrImage(frame, fileName) {
  const source = frame?.querySelector("a[download]");
  if (!source?.href) return false;
  const link = document.createElement("a");
  link.href = source.href;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  return true;
}

async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

export { copyText, getQrBase, saveQrImage };
